import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MapService } from 'src/app/services/map.service';

@Component({
  selector: 'app-layers-selected',
  templateUrl: './layers-selected.component.html',
  styleUrls: ['./layers-selected.component.scss'],
})
export class LayersSelectedComponent  implements OnInit {
  @Output() showSelected = new EventEmitter<boolean>();
  @Input() layers: any[] = [];
  @Input() layersCompare: any[] = [];

  constructor(
    public _mapService: MapService
  ) {}

  ngOnInit() {}
  setShowSelected() {
    this.showSelected.next(false);
  }

}
